<template>
    <div class="credential">
        <div class="con">
            <template v-if="channel == 'appstore'">
                <div @click="previewImg('https://img0.jihai8.com/jhimg/gzjh20250721165533.png')" class="item">
                    <p>增值电信业务经营许可证</p>
                    <span><van-icon name="arrow" /></span>
                </div>
                <div @click="goto('https://beian.miit.gov.cn/')" class="item">
                    <p>黔ICP备2020010729号-1</p>
                    <span><van-icon name="arrow" /></span>
                </div>
                <div @click="goto('https://beian.miit.gov.cn/')" class="item">
                    <p>黔ICP备2020010729号-2A</p>
                    <span><van-icon name="arrow" /></span>
                </div>
                <div @click="goto('https://beian.mps.gov.cn/#/query/webSearch?code=52011502009389')" class="item">
                    <p>贵公网安备 52011502009389号</p>
                    <span><van-icon name="arrow" /></span>
                </div>
            </template>
            <template v-else>
                <div @click="previewImg('https://img0.jihai8.com/jhimg/xzhq20250721165453.png')" class="item">
                    <p>增值电信业务经营许可证</p>
                    <span><van-icon name="arrow" /></span>
                </div>
                <div @click="goto('https://beian.miit.gov.cn/')" class="item">
                    <p>藏ICP备17000267号-1</p>
                    <span><van-icon name="arrow" /></span>
                </div>
                <div v-if="channel != 'android_jh_112'" @click="goto('https://beian.miit.gov.cn/')" class="item">
                    <p>藏ICP备17000267号-9A</p>
                    <span><van-icon name="arrow" /></span>
                </div>
                <div v-if="channel == 'android_jh_112'" @click="goto('https://beian.miit.gov.cn/')" class="item">
                    <p>藏ICP备17000267号-10A</p>
                    <span><van-icon name="arrow" /></span>
                </div>
                <div @click="goto('https://beian.mps.gov.cn/#/query/webSearch?code=54010202000433')" class="item">
                    <p>藏公网安备 54010202000433号</p>
                    <span><van-icon name="arrow" /></span>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { getQueryVariable, isJHApp } from "../../utils/base";
import jsbridg from "../../utils/jsbridg"
import { ImagePreview } from 'vant';
export default {
    name: 'credential',
    data () {
        return {
            channel: getQueryVariable('channel')
        }
    },
    mounted () {
        document.getElementsByTagName('title')[0].innerHTML = '资质证明';
        jsbridg.setTitle('资质证明')
    },
    methods: {
        goto (url) {
            if (isJHApp()) {
                jsbridg.goWebview({
                    url: url,
                    jumptype: 2
                })
            } else {
                window.location.href = url
            }
        },
        previewImg (url) {
            ImagePreview([url]);
        }
    }
}

</script>

<style lang="less" scoped>
.credential{
    width: 100%;
    min-height: 100vh;
    background-color: #f7f7f7;
    .con{
        width: 100%;
        background-color: #FFFFFF;
        .item{
            width: 100%;
            height: 38px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 15px;
            border-bottom: 1px solid #E5E5E5;
            p{
                font-size: 14px;
                color: #333333;
            }
            span{
                color: #666;
            }
        }
    }
}
</style>
